import { render, staticRenderFns } from "./MetaData.vue?vue&type=template&id=90f2bfe8&scoped=true&"
import script from "./MetaData.vue?vue&type=script&lang=js&"
export * from "./MetaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f2bfe8",
  null
  
)

export default component.exports